import { defineCustomElement } from '@tyler-components-web/core';
import { CheckboxComponent } from './checkbox';
export * from './checkbox-constants';
export * from './checkbox';
export function defineCheckboxComponent() {
    defineCustomElement(CheckboxComponent);
}
